import { render, staticRenderFns } from "./Screen_2.vue?vue&type=template&id=65653a30&scoped=true&"
import script from "./Screen_2.vue?vue&type=script&lang=ts&"
export * from "./Screen_2.vue?vue&type=script&lang=ts&"
import style0 from "./Screen_2.vue?vue&type=style&index=0&id=65653a30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65653a30",
  null
  
)

export default component.exports